"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _constants = require("libs/utils/constants");
var _utils = require("./utils");
var _lodash = require("lodash");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } // bsVideoCallsWidget
// @deprecated, to be removed when sponsors and agenda are fully migrated to Vue, the template is empty already
var VideoCallsWidgetCtrl = /* @ngInject */function VideoCallsWidgetCtrl($scope, $rootScope, $routeParams, metricsService, metadataService, modalService, userService) {
  var event = $rootScope.event;
  var vm = $scope.vm = {
    loading: false,
    model: $scope.model,
    field: $scope.field,
    label: 'Video call',
    // TODO: should be changed to $scope.label to allow modification through the metadata editor but at the time of this writing, the pkgs were outdated with the wrong name
    canJoinCall: userService.hasPermission('node_crud_realms.read_event_data', {
      event_id: event._id,
      org_id: event.ownerId
    }),
    moderatorField: {
      'video_call_moderators': {
        'label': 'Video call moderators',
        'kind': 'external',
        'kind_options': {
          'type': 'person',
          'id_field': 'fp_ext_id',
          'maxNumber': 5
        }
      }
    }
  };
  var eventId = $routeParams.eventId;
  var modelMetadata = metadataService.getCachedMetadataForType(eventId, $scope.model.fp_type);
  // this can be removed when all events have updated the sponsor and agenda packages...
  vm.canSaveModerators = !!modelMetadata.video_call_moderators;
  vm.httpsPattern = '(.*?)' + _constants.VALID_HTTPS_URL_REGEX.source + '(.*?)';
  this.$onInit = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(vm.field !== 'video_breakout_id')) {
            _context.next = 2;
            break;
          }
          throw 'Unsupported video call field';
        case 2:
          _context.next = 4;
          return fetchVideoCallDoc();
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  vm.scheduleCall = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var data, videoType;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!vm.loading) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return");
        case 2:
          if (!$scope.model['live_stream']) {
            _context2.next = 5;
            break;
          }
          modalService.openAlert({
            title: 'Error',
            message: 'This session already has a live stream. Remove the live stream to schedule a video call.'
          });
          return _context2.abrupt("return");
        case 5:
          vm.loading = true;
          _context2.prev = 6;
          _context2.next = 9;
          return window.BSTG.services.videoCalls.schedule(event.id, vm.model._id);
        case 9:
          data = _context2.sent;
          vm.model[vm.field] = data[vm.field];
          vm.model.video_call_enabled = data.video_call_enabled;
          if (data._rev !== $scope.model._rev && data[vm.field]) {
            $scope.model[vm.field] = data[vm.field];
            $scope.model._rev = data._rev;
          }
          if (vm.model.fp_type === 'session') {
            videoType = 'session-breakout';
          } else if (vm.model.fp_type === 'sponsor') {
            videoType = 'sponsor-booth';
          }
          metricsService.track('video-call-schedule', {
            id: data[vm.field],
            type: videoType
          });
          _context2.next = 20;
          break;
        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](6);
          showError('schedule', _context2.t0);
        case 20:
          _context2.next = 22;
          return fetchVideoCallDoc();
        case 22:
          vm.loading = false;
          $scope.$applyAsync();
        case 24:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[6, 17]]);
  }));
  vm.cancelCall = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var data;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!vm.loading) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return");
        case 2:
          if (vm.model[vm.field]) {
            _context3.next = 4;
            break;
          }
          return _context3.abrupt("return");
        case 4:
          vm.loading = true;
          _context3.prev = 5;
          _context3.next = 8;
          return window.BSTG.services.videoCalls.cancel(event.id, vm.model._id);
        case 8:
          data = _context3.sent;
          if (data._rev !== $scope.model._rev && !data[vm.field]) {
            $scope.model[vm.field] = null;
            vm.model.video_call_enabled = data.video_call_enabled;
            $scope.model._rev = data._rev;
          }
          _context3.next = 15;
          break;
        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](5);
          showError('cancel', _context3.t0);
        case 15:
          vm.loading = false;
          $scope.$applyAsync();
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[5, 12]]);
  }));
  vm.joinCall = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var webappUrl;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!vm.loading) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return");
        case 2:
          if (vm.model[vm.field]) {
            _context4.next = 4;
            break;
          }
          return _context4.abrupt("return");
        case 4:
          _context4.next = 6;
          return userService.getWebappLoginUrl(event.id, "/view/".concat(vm.model.fp_type, "/").concat(vm.model._id));
        case 6:
          webappUrl = _context4.sent;
          window.open(webappUrl, '_blank');
        case 8:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  var showError = function showError(action, error) {
    console.error("Could not ".concat(action, " a video call"), error);
    modalService.openAlert({
      title: 'Error',
      message: "There was an error to ".concat(action, " the call. Please reload the page and try again.")
    });
  };
  var fetchVideoCallDoc = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var _yield$window$BSTG$se, sessionDocument_rev, videoCallDoc, beforeChangeVideoCallDoc, beforeChangeModerators;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!vm.isCallScheduled()) {
              _context6.next = 20;
              break;
            }
            _context6.prev = 1;
            _context6.next = 4;
            return window.BSTG.services.videoCalls.getDoc(event.id, vm.model[vm.field]);
          case 4:
            vm.videoCallDoc = _context6.sent;
            _context6.next = 17;
            break;
          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](1);
            _context6.next = 11;
            return window.BSTG.services.videoCalls.migrateLegacyVideoCall(event.id, $scope.model._id, vm.model[vm.field]);
          case 11:
            _yield$window$BSTG$se = _context6.sent;
            sessionDocument_rev = _yield$window$BSTG$se.sessionDocument_rev;
            videoCallDoc = _yield$window$BSTG$se.videoCallDoc;
            vm.videoCallDoc = videoCallDoc;
            $scope.model._rev = sessionDocument_rev;
            vm.model[vm.field] = videoCallDoc._id;
          case 17:
            beforeChangeVideoCallDoc = (0, _lodash.cloneDeep)(vm.videoCallDoc);
            beforeChangeModerators = (0, _lodash.cloneDeep)((0, _lodash.get)(vm, 'model.video_call_moderators', []));
            vm.model.afterSave = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
              var afterSaveModerators, hasChanged, _yield$window$BSTG$se2, _rev;
              return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    afterSaveModerators = (0, _lodash.get)(vm, 'model.video_call_moderators', []);
                    if (!(0, _lodash.isEqual)(beforeChangeModerators, afterSaveModerators)) {
                      window.BSTG.services.videoCalls.notifyOnModeratorChange(event.id, vm.model._id, afterSaveModerators).catch(function (e) {
                        console.error('[VideoCallWidget] notifyOnModeratorChange error', e);
                      });
                    }
                    beforeChangeModerators = (0, _lodash.cloneDeep)((0, _lodash.get)(vm, 'model.video_call_moderators', []));
                    vm.videoCallDoc.embedded_url_enabled = !!vm.videoCallDoc.embedded_url_enabled;
                    hasChanged = !(0, _lodash.isEqual)(beforeChangeVideoCallDoc, vm.videoCallDoc);
                    if (hasChanged) {
                      _context5.next = 7;
                      break;
                    }
                    return _context5.abrupt("return");
                  case 7:
                    if (vm.videoCallDoc.embedded_url) {
                      vm.videoCallDoc.embedded_url = (0, _utils.transformToEmbeddedUrls)(vm.videoCallDoc.embedded_url);
                    }
                    _context5.next = 10;
                    return window.BSTG.services.videoCalls.updateDoc(event.id, vm.videoCallDoc);
                  case 10:
                    _yield$window$BSTG$se2 = _context5.sent;
                    _rev = _yield$window$BSTG$se2.data._rev;
                    vm.videoCallDoc._rev = _rev;
                    beforeChangeVideoCallDoc = (0, _lodash.cloneDeep)(vm.videoCallDoc);
                  case 14:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5);
            }));
          case 20:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[1, 7]]);
    }));
    return function fetchVideoCallDoc() {
      return _ref5.apply(this, arguments);
    };
  }();
  vm.isCallScheduled = function () {
    // video_breakout_cancel needs to stay for backward compatibility
    return vm.model[vm.field] && !vm.model.video_breakout_cancel;
  };
};
VideoCallsWidgetCtrl.$inject = ["$scope", "$rootScope", "$routeParams", "metricsService", "metadataService", "modalService", "userService"];
module.exports = /* @ngInject */function () {
  return {
    scope: {
      model: '=',
      field: '<',
      label: '<'
    },
    templateUrl: '/static/partials/components/form-video-calls.html',
    controller: VideoCallsWidgetCtrl
  };
};